
import React from 'react';

const TermsContent_ar: React.FC = () => (
    <div className="space-y-4 text-sm leading-relaxed text-slate-700" dir="rtl">
        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">1. ملكية الوصفات والإسناد</h3>
            <p>
                من خلال نشر المحتوى على mealPai، فإنك تقر وتوافق على أن أي وصفة مضافة من مصدر خارجي (بما في ذلك على سبيل المثال لا الحصر المواقع الإلكترونية أو كتب الطبخ أو المدونات) والتي تكون متطابقة أو مشابهة إلى حد كبير للمصدر الأصلي <strong>يجب أن تتضمن رابطاً مرجعياً مباشراً (URL) أو استشهاداً</strong> للمنشئ الأصلي إذا تم وضع علامة "عام" على الوصفة.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">2. مسؤولية المستخدم والمساءلة</h3>
            <p>
                الوصفات العامة التي يتم نسخها من مصدر خارجي دون ائتمان أو مرجع مناسب قد تشكل انتهاكاً لحقوق الملكية الفكرية.
            </p>
            <ul className="list-disc pr-5 mt-2 space-y-1">
                <li>
                    <strong>مساءلة المستخدم:</strong> المستخدم الذي ينشر المحتوى هو المسؤول الوحيد والمساءل عن ضمان أن لديه الحق في مشاركة المحتوى وتقديم الإسناد اللازم.
                </li>
                <li>
                    <strong>تحديد المسؤولية:</strong> لن تتحمل mealPai ومشغليها وموظفيها والمتطوعين والشركات التابعة لها (مدفوعة الأجر أو غير مدفوعة الأجر) <strong>أي مسؤولية أو مساءلة</strong> عن أي وصفات يتم نسخها أو نشرها أو توزيعها من قبل المستخدمين دون ائتمان مناسب أو في انتهاك لقوانين حقوق النشر.
                </li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">3. التعديلات والاستخدام العادل</h3>
            <p>
                يتم تشجيع المستخدمين على اقتراح تغييرات أو تعديلات أو تحسينات على الوصفات. ومع ذلك، يجب أن تظل هذه الاقتراحات والتعديلات المنشورة ضمن حدود قوانين حقوق النشر المعمول بها. التحول الجوهري للوصفة لا يلغي تلقائياً شرط الإسناد إذا كان العمل الأساسي مشتقاً من مصدر محمي.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">4. المحتوى والسلوك المحظور</h3>
            <p>
                يُحظر تماماً على المستخدمين نشر محتوى يتضمن لغة بذيئة أو مسيئة أو عنصرية أو وحشية أو خطاب كراهية أو لغة غير لائقة بأي شكل آخر.
            </p>
            <ul className="list-disc pr-5 mt-2 space-y-1">
                <li>
                    <strong>عدم التسامح مطلقاً:</strong> تحافظ mealPai على سياسة عدم التسامح مطلقاً تجاه المضايقات وخطاب الكراهية والمحتوى المسيء.
                </li>
                <li>
                    <strong>إلغاء تنشيط الحساب:</strong> سيتم تحميل أي مستخدم يثبت أنه مسؤول عن نشر مثل هذا المحتوى المسؤولية الشخصية. تحتفظ mealPai بالحق في <strong>إلغاء تنشيط حساب</strong> أي مستخدم ينتهك هذه السياسة فوراً، دون إشعار مسبق.
                </li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">5. إزالة المحتوى</h3>
            <p>
                تحتفظ mealPai بالحق، ولكنها لا تتحمل الالتزام، بإزالة أي محتوى يتم الإبلاغ عنه أو اكتشافه على أنه ينتهك هذه الشروط أو قوانين الملكية الفكرية المعمول بها، دون إشعار مسبق للمستخدم.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">6. الأسعار والاشتراكات</h3>
            <p>
                حالياً، يتم توفير mealPai مجاناً للاختبار والاستخدام الشخصي. ومع ذلك، نحتفظ بالحق في تقديم خطط اشتراك مدفوعة أو رسوم خدمة في المستقبل. قد يتطلب الوصول إلى ميزات متميزة معينة أو حدود استخدام أعلى اشتراكاً مدفوعاً. سيتم إخطار المستخدمين مسبقاً بأي تغييرات إلزامية في نموذج التسعير.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">7. استمرارية وفقدان البيانات</h3>
            <p>
                بينما نبذل جهوداً معقولة للحفاظ على أمن وسلامة بياناتك، يتم توفير mealPai "كما هو" و "حسب توفره". نحن <strong>نخلي مسؤوليتنا صراحة عن أي مسؤولية تجاه فقدان البيانات</strong> (بما في ذلك الوصفات أو خطط الوجبات أو سجل الحساب) الذي يحدث بمرور الوقت بسبب أخطاء فنية، أو عمليات نقل النظام، أو فشل قاعدة البيانات، أو حذف الحساب.
            </p>
            <p className="mt-2">
                نحن نشجع المستخدمين بشدة على استخدام ميزة <strong>"تصدير البيانات"</strong> المتاحة في القائمة بشكل دوري للاحتفاظ بنسخ احتياطية شخصية لمعلوماتهم.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">8. استخدام الذكاء الاصطناعي (AI) وإخلاء المسؤولية</h3>
            <p>
                يستخدم التطبيق (mealPai) تقنيات الذكاء الاصطناعي (AI) لتحليل الوصفات، واستخراج المكونات، وإصدار تحذيرات الحساسية، وتحليل الوجبات المناسبة للمستخدم. يرجى العلم أن هذه التقنية ليست معصومة من الأخطاء وقد تقدم أحياناً معلومات خاطئة أو ناقصة أو غير دقيقة.
            </p>
            <p className="mt-2">
                يُقدَّم كل المحتوى الذي يولّده الذكاء الاصطناعي كتوصية ولأغراض إعلامية فقط. يجب على المستخدمين توخي الحذر واستخدام حكمهم المستقل. تقع على عاتق المستخدم وحده مسؤولية مراجعة والتحقق يدوياً من جميع المكونات وتحذيرات الحساسية (لا سيما في حالات الحساسية الشديدة أو القيود الغذائية الصارمة) قبل تحضير أي طعام أو تناوله. الاعتماد على هذه المعلومات يكون على مسؤولية المستخدم وحده.
            </p>
        </section>
    </div>
);

export default TermsContent_ar;
